import React from "react";
import Enrolment from "../Enrolment";

const EnrollmentTrainingComponent = () => {
  return <Enrolment status="training" title="training" />;
};

export default EnrollmentTrainingComponent;
